import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box, styled, Typography } from '@mui/material';

export const TypographyStyled = styled(Typography)(({ theme }) => ({
  fontSize: '12px',
  fontWeight: 400,
  fontStretch: 'normal',
  fontStyle: 'normal',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.variantOnPrimaryBackground,
}));

export const StarIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  fontSize: '16px',
}));

export const EyeIconStyled = styled(FontAwesomeIcon)(({ theme }) => ({
  color: theme.palette.colors.mainFocused,
  fontSize: '16px',
}));

export const BoxStyled = styled(Box)(({ theme }) => ({
  marginTop: '28px',
  padding: '12px 16px 12px 16px',
  borderRadius: '5px',
  border: `solid 1px ${theme.palette.colors.borderLine}`,
  backgroundColor: theme.palette.colors.selectedAndDetailBackground,
}));
